/**
 * Utility functions for converting video URLs to embeddable formats
 */

export const convertToEmbedUrl = (url: string): string | null => {
  if (!url || typeof url !== 'string') return null;

  try {
    const normalizedUrl = url.trim();
    
    // YouTube URL patterns
    const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const youtubeMatch = normalizedUrl.match(youtubeRegex);
    
    if (youtubeMatch) {
      const videoId = youtubeMatch[1];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Vimeo URL patterns
    const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:video\/)?(\d+)/;
    const vimeoMatch = normalizedUrl.match(vimeoRegex);
    
    if (vimeoMatch) {
      const videoId = vimeoMatch[1];
      return `https://player.vimeo.com/video/${videoId}`;
    }

    // If it's already an embed URL, return as is
    if (normalizedUrl.includes('/embed/') || normalizedUrl.includes('player.')) {
      return normalizedUrl;
    }

    return null;
  } catch (error) {
    console.error('Error converting video URL:', error);
    return null;
  }
};

export const isValidVideoUrl = (url: string): boolean => {
  return convertToEmbedUrl(url) !== null;
};

export const getVideoProvider = (url: string): string | null => {
  if (!url) return null;
  
  if (url.includes('youtube.com') || url.includes('youtu.be')) {
    return 'YouTube';
  }
  
  if (url.includes('vimeo.com')) {
    return 'Vimeo';
  }
  
  return 'Video';
};